export { default } from './toPairs.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/entries.js
// module id = 230
// module chunks = 0